const type = "SENSOR/";

export const sensorLiveDataConstants = {
  LIVE_DATA_REQUEST: `${type}LIVE_DATA_REQUEST`,
  LIVE_DATA_SUCCESS: `${type}LIVE_DATA_SUCCESS`,
  LIVE_DATA_FAILURE: `${type}LIVE_DATA_FAILURE`,
};
